import { DossierId } from '../../../resources/dossier/types';
import { NEW_REQUEST_STEP } from '../../../domain';
import { useDossierOverviewFromId, useHasMultipleMarkets } from '../../../resources/pipeline/hooks';
import { useGetAgents, useCanDisplayAvatar } from '../../../resources/agent/hooks';

import { DossierOverview } from './DossierOverview';
import { NewRequestDossierOverview } from './NewRequestDossierOverview';

export const DndOverlayDossierOverview = ({ id }: { id: DossierId }) => {
    const { data: agents } = useGetAgents();
    const hasMultipleMarkets = useHasMultipleMarkets();
    const dossier = useDossierOverviewFromId(id);

    const canDisplayAvatar = useCanDisplayAvatar(dossier?.agentId);

    if (!dossier) return null;

    return dossier.step === NEW_REQUEST_STEP ? (
        <NewRequestDossierOverview dossier={dossier} />
    ) : (
        <DossierOverview
            isDragging={true}
            isDragOverlay={true}
            agents={agents}
            displayAvatar={canDisplayAvatar}
            dossier={dossier}
            id={id}
            hasMultipleMarkets={hasMultipleMarkets}
            isLatestUpdated={false}
        />
    );
};
